import styled from 'styled-components';
import { breakpoints } from 'modules/breakpoints';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
import { TableBodyCell } from '../TableCell';
import { TableRow } from '../TableRow/TableRow';
export const TableCollapseBodyCell = styled.td `
  padding: ${theme.spacing.sm} ${theme.spacing.md};

  ${breakpoints.sm} {
    ${(props) => `padding: ${theme.spacing.xl} calc(${theme.spacing['2xl']} + ${pxToRem(props.$offset)});`}
  }
`;
export const StyledTableBodyCell = styled(TableBodyCell) `
  ${(props) => props.$hideOnBreakpoint && breakpoints[props.$hideOnBreakpoint]} {
    display: none;
  }
`;
export const TableCollapseRow = styled(TableRow) `
  ${(props) => props.$hideOnBreakpoint && breakpoints[props.$hideOnBreakpoint]} {
    display: none;
  }
`;
